import React from "react";
import CreatePassword from "./CreatePassword";
// import loginvactor from "../../assets/svg/login-vactor.svg";
// import Forgot from "../../assets/svg/forgot-password.svg";
import confirmVactor from "../../../assets/svg/confirm-password.svg";
import topVactor from "../../../assets/svg/top-shape.svg";
import bottomVactor from "../../../assets/svg/bottom-shape.svg";
import getworkLogo from "../../../assets/png/partner-logo.png";
import getworkBottomLogo from "../../../assets/png/getworkBottomLogo.png";

const ResetPassword = () => {
  return (
    <div className="fixed w-full h-screen flex items-start">
      <div className=" relative w-[55%] bg-[#fafafa] h-full flex flex-col aliggn items-center justify-center ">
        <div className="absolute top-0 left-0">
          <img src={topVactor} alt="top-vactor" />
        </div>

        <img
          src={confirmVactor}
          alt="logo"
          className="w-4/6 aspect-3/2 object-contain "
        />
        <div className="absolute bottom-0 right-0">
          <img src={bottomVactor} alt="top-vactor" />
        </div>
      </div>

      <div className="relative w-[45%] h-full  flex flex-col  items-center p-2 scroll-smooth overflow-y-auto">
        <img
          src={getworkLogo}
          alt="getwork-logo"
          className="w-16 aspect-3/2 object-contain pt-10 "
        />
        <h1 className="mt-6 text-3xl normal-case  ">Create new password</h1>
        <p className="text-center text-gray-600 mt-3 text-sm pl-[15%] pr-[15%]">
          Your new password must be different from previous used passwords
        </p>

        <CreatePassword />
        <div className="w-full sticky bottom-1 top-[100%] flex items-center justify-center">
          <p className="text-sm ">Powered by</p>{" "}
          <img
            src={getworkBottomLogo}
            className="ml-2"
            alt="bootom-getwork-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
